<template>
<div>
  <el-select :size="size" v-model="selected" value-key="code" filterable remote reserve-keyword placeholder="请输入编码或名称" :remote-method="queryMaterial" :loading="loading" @change="materialSelected">
    <el-option value=" " disabled>
      <el-row style="width:60rem;" :gutter="15">
        <el-col :span="4">
          名称
        </el-col>
        <el-col :span="3">
          规格
        </el-col>
        <el-col :span="3" class="right">
          单位
        </el-col>
        <el-col :span="3">
          单价
        </el-col>
        <el-col :span="2" class="center">
          助记符
        </el-col>
      </el-row>
    </el-option>
    <el-option v-for="material in materials" :key="material.id" :label="material.name" :value="material" style="font-size:0.5rem;">
      <el-row style="width:60rem;border-top:solid 1px #EEE" :gutter="15">
        <el-col :span="4" class="text-ellipsis" :title="material.name">
          {{ material.name }}
        </el-col>
        <el-col :span="3" class="text-ellipsis" :title="material.standard">
          {{ material.standard }}
        </el-col>
        <el-col :span="3" class="right">
          {{material.unit | dictText('Unit')}}
        </el-col>
      
        <el-col :span="3" class="text-ellipsis">
             {{material.price}}
        </el-col>
        <el-col :span="2" class="center">
          <span>{{material.mnemonic}}</span>
        </el-col>
      </el-row>
    </el-option>
  </el-select>

  </div>
  

</template>
<script>
import api from './api'
export default {
  props: {
    value: Object,
    size: String,
    items:  {
      type:Array,
      default:()=>{
        return []
      }
    },
    condition: {type: Object, default: () => {return {
        keyword: null,
        disabled:false,
        sort: "id",
        asc: false,
        pageIndexOnView: 1,
        pageSize: 20
      }}}
  },
  data () {
    return {
     
      selected: null,
      loading: false,
      materials:[]
    }
  },
  watch: {
    value () {
      this.autoSelect()
    }
  },
  mounted() {
    this.autoSelect()
  },
  methods: {
    autoSelect() {
      if (this.value) {
        if (!this.selected || this.selected.code != this.value.code) {
          let selected =  this.$utils.Obj.clone(this.value)
          this.$set(this, 'materials', [selected])
          this.$set(this, 'selected', selected)
        }
      }
    },
    queryMaterial(code) {
      this.loading = true
      this.condition.keyword = code
      this.condition.disabled = false
      if (!this.condition.sort) {
        this.condition.sort = 'id'
      }
      if (!this.condition.asc) {
        this.condition.asc = false
      }
      if (!this.condition.pageIndexOnView) {
        this.condition.pageIndexOnView = 1
      }
      if (!this.condition.pageSize) {
        this.condition.pageSize = 20
      }
      api.Standard.query(this.condition).then(res => {
        if (res) {
          this.materials = res.items;
        }
      }).finally(()=> {
        this.loading = false
      });
    },
    materialSelected(material) {
      let fid = this.items.find(item => item.code == material.code)
      if (fid) {
        this.$message.error('已经添加过此项目，请勿重复添加！')
        this.selected = null;
        return 
      } 
       delete material.id
       this.$utils.Obj.propertyCopy(material, this.value, [
        {src: "code", tgt: "code"},
        {src: "feeType", tgt: "feeType"},
        {src: "name", tgt: "name"},
        {src: "shortCode", tgt: "shortCode"},
        {src: "standard", tgt: "standard"},
        {src: "type", tgt: "type"},
        {src: "unit", tgt: "unit"},
        {src: "manufacturerCode", tgt: "manufacturerCode"},
        {src: "cost", tgt: "cost"},
        {src: "approvalNumber", tgt: "approvalNumber"},
      ], this)
      this.value.id = null
      this.value.quantity = 1
      this.$emit('materialSelected', material)
     
    },
  }
};
</script>
<style scoped>
.text-ellipsis {
  white-space: nowrap;
text-overflow: ellipsis;
overflow: hidden;
word-break: break-all;
}
.el-col {
  min-height: 1px
}
</style>
